const LOCAL_STORAGE_NAME = 'payjim_local_data';
class StateManager {
  loadState() {
    try {
      const serializedState = localStorage.getItem(LOCAL_STORAGE_NAME);

      if (serializedState === null) {
        return this.initializeState();
      }

      return JSON.parse(serializedState);
    } catch (err) {
      return this.initializeState();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  saveState(state) {
    try {
      const serializedState = JSON.stringify(state);
      localStorage.setItem(LOCAL_STORAGE_NAME, serializedState);
      // eslint-disable-next-line no-empty
    } catch (err) {}
  }

  // eslint-disable-next-line class-methods-use-this
  initializeState() {
    return {};
  }
}
export default StateManager;
